import { BrowserRouter, Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { useState } from 'react';
import Header from './components/Header/Header';
import ScrollToTop from './components/ScrollToTop';
import Home from './pages/Home';
import AuthPage from './pages/auth/Auth.jsx';
import AccountLayout from './pages/Account/AccountLayout';
import AccountProfile from './pages/Account/AccountProfile';
// import AccountPassword from './pages/Account/AccountPassword';
import AccountOrders from './pages/Account/AccountOrders';
import AccountBonuses from './pages/Account/AccountBonuses';
import RequireAuth from './components/RequireAuth/RequireAuth';
import RequireRole from './components/RequireAuth/RequireRole';
import ProductCreate from './pages/Admin/ProductCreate';
import AdminLayout, { AdminHomeRedirect } from './pages/Admin/AdminLayout';
import CatalogIndex from './pages/Catalog/Index';
import CategoryPage from './pages/Catalog/Category';
import { CartProvider } from './context/CartContext';
import ProductDetail from './pages/Product/ProductDetail';
import { FavoritesProvider } from './context/FavoritesContext';
import CartPage from './pages/Cart/Cart';
import WishlistPage from './pages/Wishlist/Wishlist';
import FloatingContacts from './components/FloatingContacts';
import AdminInventory from './pages/Admin/AdminInventory';
import AdminReports from './pages/Admin/AdminReports';
import AdminSales from './pages/Admin/AdminSales';
import AdminProductEdit from './pages/Admin/AdminProductEdit';
import Footer from './components/Footer/Footer';
import CookieNotice from './components/CookieNotice/CookieNotice';
import YandexMetrika from './components/analytics/YandexMetrika';
import Cookies from './pages/Legal/Cookies';
import CartDrawer from './components/CartDrawer/CartDrawer';
import Oferta from './pages/Legal/Oferta';
import Privacy from './pages/Legal/Privacy';
import Delivery from './pages/Legal/Delivery';
import Contacts from './pages/Legal/Contacts';
import ReturnMemo from './pages/Legal/ReturnMemo';
import AdminArchive from './pages/Admin/AdminArchive';
import AdminUsers from './pages/Admin/AdminUsers';
import AdminCategories from './pages/Admin/AdminCategories';
import AdminOrders from './pages/Admin/AdminOrders';
import AdminOrderDetails from './pages/Admin/AdminOrderDetails';
import AdminSellerProfiles from './pages/Admin/AdminSellerProfiles';
import AdminStoreSettings from './pages/Admin/AdminStoreSettings';
import PaymentSuccess from './PaymentSuccess.jsx';
import PaymentFail from './PaymentFail.jsx';

function AppShell() {
  const [isCartOpen, setCartOpen] = useState(false);
  const { pathname } = useLocation();
  const isAdmin = pathname.startsWith('/admin');

  return (
    <div className="app">
      <ScrollToTop />
      {!isAdmin && <FloatingContacts />}
      {!isAdmin && <Header onCartClick={() => setCartOpen(true)} />}

      <main className={isAdmin ? 'site-main site-main--admin' : 'site-main'}>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/auth" element={<AuthPage />} />
          <Route path="/auth/verify" element={<AuthPage />} />
          <Route path="/auth/reset" element={<AuthPage />} />
          <Route path="/catalog" element={<CatalogIndex />} />
          <Route path="/catalog/:category" element={<CategoryPage />} />
          <Route path="/catalog/:category/:sub" element={<CategoryPage />} />
          <Route path="/p/:slug" element={<ProductDetail />} />

          {/* admin */}
          <Route
            path="/admin"
            element={
              <RequireRole allow={['admin', 'manager']}>
                <AdminLayout />
              </RequireRole>
            }
          >
            <Route index element={<AdminHomeRedirect />} />
            <Route
              path="products/new"
              element={
                <RequireRole allow={['admin']} fallback="/admin/orders">
                  <ProductCreate />
                </RequireRole>
              }
            />
            <Route
              path="categories"
              element={
                <RequireRole allow={['admin']} fallback="/admin/orders">
                  <AdminCategories />
                </RequireRole>
              }
            />
            <Route path="inventory" element={<AdminInventory />} />
            <Route path="sales" element={<AdminSales />} />
            <Route path="reports" element={<AdminReports />} />
            <Route path="orders" element={<AdminOrders />} />
            <Route path="orders/:id" element={<AdminOrderDetails />} />

            <Route path="archive" element={<AdminArchive />} />
            <Route path="users" element={<AdminUsers />} />
            <Route
              path="seller-profiles"
              element={
                <RequireRole allow={['admin']} fallback="/admin/orders">
                  <AdminSellerProfiles />
                </RequireRole>
              }
            />
            <Route
              path="settings"
              element={
                <RequireRole allow={['admin']} fallback="/admin/orders">
                  <AdminStoreSettings />
                </RequireRole>
              }
            />
            <Route
              path="products/:id/edit"
              element={
                <RequireRole allow={['admin']} fallback="/admin/inventory">
                  <AdminProductEdit />
                </RequireRole>
              }
            />
          </Route>

          {/* корзина и избранное */}
          <Route path="/cart" element={<CartPage />} />
          <Route path="/wishlist" element={<WishlistPage />} />

          {/* аккаунт */}
          <Route
            path="/account"
            element={
              <RequireAuth>
                <AccountLayout />
              </RequireAuth>
            }
          >
            <Route index element={<Navigate to="profile" replace />} />
            <Route path="profile" element={<AccountProfile />} />
            {/* <Route path="password" element={<AccountPassword />} /> */}
            <Route path="orders" element={<AccountOrders />} />
            <Route path="bonuses" element={<AccountBonuses />} />
          </Route>

          {/* документы */}
          <Route path="/oferta" element={<Oferta />} />
          <Route path="/privacy" element={<Privacy />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/delivery" element={<Delivery />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/return-memo" element={<ReturnMemo />} />

          {/* оплата — ДО catch-all, иначе success/fail недостижимы */}
          <Route path="/payment/success" element={<PaymentSuccess />} />
          <Route path="/payment/fail" element={<PaymentFail />} />

          {/* fallback */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </main>

      {!isAdmin && <Footer />}
      {!isAdmin && <CartDrawer open={isCartOpen} onClose={() => setCartOpen(false)} />}
      {!isAdmin && <CookieNotice />}
      {!isAdmin && <YandexMetrika />}
    </div>
  );
}

export default function App() {
  return (
    <FavoritesProvider>
      <CartProvider>
        <BrowserRouter>
          <AppShell />
        </BrowserRouter>
      </CartProvider>
    </FavoritesProvider>
  );
}
